import { css } from 'styled-components';
import { color, themeMode, Breakpoints } from '@landr/maestro';
import {
    UnbHeightPx,
    NavHeightPxDesktop,
    NavHeightPxMobile,
    CreatorHeaderHeightPxDesktop,
    CreatorHeaderHeightPxMobile,
} from '../../../constants';

const SectionRoot = css({});

const MinHeight = {
    base: css`
        min-height: 100%;
    `,
    sixty: css`
        min-height: calc(60vh + 1px);
    `,
    fullHeight: css`
        min-height: 100vh;
    `,
    fullHeightMinusCreator: css`
        min-height: calc(100vh - ${CreatorHeaderHeightPxDesktop}px);

        ${({ theme }): string => theme.breakpoint('md')`
            min-height: calc(100vh - ${CreatorHeaderHeightPxMobile}px);
        `}
    `,
};

const Offset = {
    base: css``,
    header: css`
        top: calc(-${UnbHeightPx}px - ${NavHeightPxDesktop}px);
        margin-bottom: calc(-${UnbHeightPx}px - ${NavHeightPxDesktop}px);
        padding-top: calc(${UnbHeightPx}px + ${NavHeightPxDesktop}px);

        ${({ theme }): string => theme.breakpoint('md')`
            top: calc(-${UnbHeightPx}px - ${NavHeightPxMobile}px);
            margin-bottom: calc(-${UnbHeightPx}px - ${NavHeightPxMobile}px);
            padding-top: calc(
                ${UnbHeightPx}px + ${NavHeightPxMobile}px}
            );
        `}
    `,
};

const Position = {
    center: css``,
    bottom: css`
        align-items: flex-end;
        padding-top: inherit;
        padding-bottom: inherit;
    `,
};

const Variant = {
    primary: themeMode({
        light: css({
            backgroundColor: 'transparent',
        }),
        dark: css({
            backgroundColor: 'transparent',
        }),
    }),
    secondary: themeMode({
        light: css`
            background-color: ${color('neutral.900')};
        `,
        dark: css`
            background-color: ${color('neutral.50')};
        `,
    }),
    ghost: themeMode({
        light: css`
            background-color: ${color('neutral.100')};
        `,
        dark: css`
            background-color: ${color('neutral.900')};
        `,
    }),
};

const Boxed = {
    sm: css`
        max-width: ${Breakpoints.sm}px;
    `,
    ms: css`
        max-width: ${Breakpoints.ms}px;
    `,
    md: css`
        max-width: ${Breakpoints.md}px;
    `,
    lg: css`
        max-width: ${Breakpoints.lg}px;
    `,
    xl: css`
        max-width: ${Breakpoints.xl}px;
    `,
    xxl: css`
        max-width: ${Breakpoints.xxl}px;
    `,
    jb: css`
        max-width: ${Breakpoints.jb}px;
    `,
    full: css``,
};

const styles = {
    root: SectionRoot,
    minHeight: MinHeight,
    offset: Offset,
    position: Position,
    variant: Variant,
    boxed: Boxed,
};

export default styles;
